import React from "react";

import AppSideMenu from "./SideMenu/SideMenu";
import AppFooter from "./Footer";

import styled from "styled-components";

import classNames from "classnames/bind";
import styles from "./Layout.module.scss";
const cx = classNames.bind(styles);

const AppLayout = styled.div`
  ${(props) => {
    const { theme } = props;

    return `background-color:${theme.Primary};`;
  }}
`;

const Container = styled.div`
  /* background-color: #fff;
  height: 100%;
  flex-grow: 1;
  border-radius: 20px; */
`;

const Body = styled.div``;

const SideMenu = styled(AppSideMenu)``;

const Footer = styled(AppFooter)``;

interface LayoutProps {
  children: React.ReactNode;
  layout?: number;
  structure: {
    header?: boolean;
    sideMenu?: boolean;
    footer?: boolean;
  };
}

const Layout = (props: LayoutProps) => {
  const { children, structure = {}, layout } = props;

  const { sideMenu, footer } = structure;

  return (
    <AppLayout className={cx("appLayout", { homeLayout: layout === 0 })}>
      <div className={cx("appWrapper")}>
        {sideMenu && <SideMenu />}

        <Container className={cx("appContext")}>
          <Body>{children}</Body>
        </Container>

        {footer && <Footer align="center" />}
      </div>
    </AppLayout>
  );
};

export default Layout;
